import http from "./core";
import SessionService from "./session";

const config = require("./serverCfg").default;
const basePath = "api/portal/Documents";

export const DocumentsService = {
  async get(id) {
    const result = await http.get(`${basePath}/${id}`);
    return result.data;
  },
  getAll() {
    return http.get(`${basePath}/FindAll`);
  },
  async getSharedDocument(id) {
    const result = await http.get(`${basePath}/FindSharedDocument/` + id);
    return result.data;
  },
  async query(formId, clientId, eocId) {
    const result = await http.post(`${basePath}/ByEoc/${formId}/${eocId}`);
    return result.data;
  },
  update(sharedDocumentId, data) {
    return http.patch(`${basePath}/${sharedDocumentId}`, data);
  },
  updateAndComplete(id, data) {
    return http.patch(`${basePath}/${id}/SaveAndComplete`, data);
  },
  create(sharedDocumentId, data) {
    return http.put(`${basePath}/${sharedDocumentId}`, data);
  },
  createAndComplete(data) {
    return http.put(`${basePath}/CreateAndComplete`, data);
  },
  render(docId) {
    return http.get(`${basePath}/RenderDocument/${docId}`);
  },
  upload(sharedDocumentId, data) {
    const { file } = data;
    const formData = new FormData();
    if (file) formData.append("File", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return http.put(`${basePath}/Upload/${sharedDocumentId}`, formData, config);
  },
  viewUrl(id) {
    return `${http.defaults.baseURL}${basePath}/Download/${
      SessionService.session().token
    }/${id}`;
  },
  documentViewUrl(documentId) {
    return {
      url: `${config.coreBaseUrl}${basePath}/RenderDocument/${documentId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SessionService.session().token}`
      }
    };
  }
};

export default DocumentsService;
